
export default {
  valueType: 'money',
  FormItemProps: {
    label: '金额',
    rules: [
      {
        pattern: /^(([1-9]\d*)|\d)(\.\d{1,2})?$/,
        message: "不能超过小数点后两位"
      }
    ],
    style: {}
  },
  ControlProps: {
    prefix: "￥", // 带有前缀图标的 input
    suffix: "", // 带有后缀图标的 input
    disabled: false,
    min: null,
    max: null,
    placeholder: "",
    step: "0.01",
    style: {}
  },
}
